import { Injectable } from '@angular/core';
import { MatSnackBar} from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  constructor(
    public _snackbar: MatSnackBar
  ) { }

  snackbar(msj: string) {
    this._snackbar.open(msj, 'x');
  }
}
